export const customPagesTranslation = {
  en: {
    "S.No": "S.No",
    "Page Title": "Page Title",
    Subtitle: "Subtitle",
    URL: "URL",
    "Is Header": "Is Header",
    "Is Footer": "Is Footer",
    "Is Second Footer": "Is Second Footer",
    "Is Login": "Is Login",
    "Created At": "Created At",
    Status: "Status",
    Actions: "Actions",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    "Custom Pages": "Custom Pages",
    "+ Add Page": "+ Add Page",
    "Search by title...": "Search by title...",
    "Page Title (EN)": "Page Title (EN)",
    "Page Title (AR)": "Page Title (AR)",
    "Subtitle (EN)": "Subtitle (EN)",
    "Subtitle (AR)": "Subtitle (AR)",
    "Page URL": "Page URL",
    "Page Content (EN)": "Page Content (EN)",
    "Page Content (AR)": "Page Content (AR)",
    True: "True",
    False: "False",
    "Edit Page": "Edit Page",
    "Add New Page": "Add New Page",
    "Update Page": "Update Page",
    "Add Page": "Add Page",
    "Are you sure you want to delete page '{{title}}'?":
      "Are you sure you want to delete page '{{title}}'?",
    Cancel: "Cancel",
    Delete: "Delete",
    "This action cannot be undone.": "This action cannot be undone.",
    Active: "Active",
    Inactive: "Inactive",
  },
  ar: {
    "S.No": "رقم",
    "Page Title": "عنوان الصفحة",
    Subtitle: "العنوان الفرعي",
    URL: "الرابط",
    "Is Header": "يظهر في التروسية",
    "Is Footer": "يظهر في التذييل",
    "Is Second Footer": "يظهر في التذييل الثانوي",
    "Is Login": "يظهر في تسجيل الدخول",
    "Created At": "تاريخ الإنشاء",
    Status: "الحالة",
    Actions: "الإجراءات",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    "Custom Pages": "الصفحات المخصصة",
    "+ Add Page": "+ إضافة صفحة",
    "Search by title...": "البحث حسب العنوان...",
    "Page Title (EN)": "عنوان الصفحة (EN)",
    "Page Title (AR)": "عنوان الصفحة (AR)",
    "Subtitle (EN)": "العنوان الفرعي (EN)",
    "Subtitle (AR)": "العنوان الفرعي (AR)",
    "Page URL": "رابط الصفحة",
    "Page Content (EN)": "محتوى الصفحة (EN)",
    "Page Content (AR)": "محتوى الصفحة (AR)",
    True: "نعم",
    False: "لا",
    "Edit Page": "تعديل الصفحة",
    "Add New Page": "إضافة صفحة جديدة",
    "Update Page": "تحديث الصفحة",
    "Add Page": "إضافة صفحة",
    "Are you sure you want to delete page '{{title}}'?":
      "هل أنت متأكد أنك تريد حذف الصفحة '{{title}}'؟",
    Cancel: "إلغاء",
    Delete: "حذف",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Active: "نشط",
    Inactive: "غير نشط",
  },
};
